import React, { useEffect, useState } from 'react';
import NavBar from '../../component/b2c/navBar/navBar';
import Sidebar from '../../component/b2c/sidebar/sidebar';
import { useMyContext } from '../../context/MyContext';
import '../../css/custom-scrollbar.css';
import { FaUser } from "react-icons/fa";
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { Button } from '@mui/material';
import { IoMdEye } from 'react-icons/io';
import { MdDelete } from 'react-icons/md';
import axios from 'axios';
import Swal from "sweetalert2";
import { Base_Url, userlist, deleteuser } from '../../config/config';
import { toast } from 'react-toastify';
import '../../../src/css/custom-scrollbar.css'
import { CiEdit } from "react-icons/ci";
import { AiOutlineDownload } from "react-icons/ai";
import { Search } from 'lucide-react';
import ViewAllCustomerModel from '../../component/b2c/models/ViewAllCustomerModel';

const ViewAllCustomer = () => {
  const { isDarkMode, isToggleSidebar,setIsToggleSidebar } = useMyContext();
  const [customers, setCustomers] = useState([]);
  const [totalCustomer, setTotalCustomers] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');


  useEffect(() => {
    fetchCustomers();
  }, [currentPage, limit]);

  const handleViewClick = (customer) => {
    setSelectedCustomer(customer);
    setIsPopupOpen(true);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleDownloadCSV = (customer) => {
    const csvContent = `data:text/csv;charset=utf-8,${[
      ["ID", "Name", "Email", "Phone", "Company Name", "Company Type", "GST No", "Pancard No", "Aadharcard No"],
      [customer.id,
      customer.name,
      customer.email,
      customer.phone,
      customer.company_name,
      customer.company_type,
      customer.gst_number,
      customer.pancard_number,
      customer.aadhar_number
      ]
    ]
      .map((row) => row.join(","))
      .join("\n")}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `customer_${customer.id}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadAllCustomers = () => {
    const csvContent = [
      ["ID", "Name", "Email", "Phone", "Company Name", "Company Type", "GST No", "Pancard No", "Aadharcard No"],
      ...customers.map(customer => [
        customer.id,
        customer.name,
        customer.email,
        customer.phone,
        customer.company_name,
        customer.company_type,
        customer.gst_number,
        customer.pancard_number,
        customer.aadhar_number
      ])
    ]
      .map(row => row.join(","))
      .join("\n");

    if (customers.length === 0) {
      toast.error("No customers available to download");
      return;
    }

    const encodedUri = encodeURI(`data:text/csv;charset=utf-8,${csvContent}`);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "all_customers.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchCustomers = async () => {
    const url = `${Base_Url}admin/${userlist}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        const filteredCustomers = data.data.filter(customer => customer.role !== 'admin');
        const adminCount = data.data.filter(customer => customer.role === 'admin').length;
        const adjustedTotal = data.pagination.totalItems - adminCount;

        setCustomers(filteredCustomers);
        setTotalCustomers(adjustedTotal || 0);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const getFilteredCustomers = () => {
    if (!searchTerm.trim()) {
      return customers;
    }

    const term = searchTerm.toLowerCase();
    return customers.filter(customer => {
      return (
        (customer.id?.toString().toLowerCase().includes(term)) ||
        (customer.name?.toLowerCase().includes(term)) ||
        (customer.phone?.toString().toLowerCase().includes(term))
      );
    });
  };

  const displayCustomers = getFilteredCustomers();

  const handleLimitChange = (e) => {
    setLimit(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handlePaginationChange = (e, value) => {
    setCurrentPage(value);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows([...Array(customers.length).keys()]);
    } else {
      setSelectedRows([]);
    }
    setSelectAll(e.target.checked);
  };

  const handleRowSelect = (index) => {
    setSelectedRows((prev) => {
      const isSelected = prev.includes(index);
      if (isSelected) {
        return prev.filter(i => i !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  // 🔥 UI-only toggle (no API call yet)
  const handleStatusToggle = (customerId) => {
    setCustomers((prev) =>
      prev.map((c) =>
        c.id === customerId
          ? { ...c, status: c.status === 1 || c.status === "active" ? 0 : 1 }
          : c
      )
    );
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this deletion!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#000000',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const urldelete = Base_Url + deleteuser;
        try {
          const token = localStorage.getItem('token');
          const cusid = localStorage.getItem('cus_id');
          const data = {
            retailer_id: id
          };
          const response = await axios.post(urldelete, data, {
            headers: {
              token,
              cus_id: cusid,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });

          if (response.data.status === "SUCCESS") {
            fetchCustomers();
            Swal.fire(
              'Deleted!',
              response.data.message || 'Reatiler has been deleted successfully.',
              'success'
            );
          } else {
            Swal.fire(
              'Error!',
              'Unexpected response format: ' + response.data.message,
              'error'
            );
          }
        } catch (error) {
          Swal.fire(
            'Error!',
            'Error deleting Retailer: ' + error.message,
            'error'
          );
        }
      }
    });
  };

  const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

  // Mobile card view for each customer
  const renderMobileCard = (customer, index) => {
    const isActive = customer.status === 1 || customer.status === "active";

    return (
      <div
        key={customer.id || index}
        className={`rounded-xl border overflow-hidden transition-all duration-200 ${
          isDarkMode
            ? 'bg-gradient-to-br from-[#0f172a] via-[#0b1220] to-[#0f172a] border-indigo-500/25 shadow-[0_4px_20px_rgba(79,70,229,0.15)]'
            : 'bg-white border-gray-200 shadow-sm'
        }`}
      >
        {/* Top strip: Name + ID */}
        <div className={`flex items-center justify-between gap-3 px-3 py-2.5 border-b ${
          isDarkMode
            ? 'bg-gradient-to-r from-indigo-600/20 via-purple-600/15 to-indigo-600/20 border-indigo-500/25'
            : 'bg-gray-50 border-gray-200'
        }`}>
          <div className="min-w-0 flex-1">
            <p className={`text-[9px] uppercase tracking-wider mb-0.5 font-semibold ${
              isDarkMode ? 'text-indigo-300/80' : 'text-gray-400'
            }`}>
              Name
            </p>
            <p className={`text-[12px] font-semibold truncate ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>
              {customer.name || '—'}
            </p>
          </div>
          <div className="text-right shrink-0">
            <p className={`text-[9px] uppercase tracking-wider mb-0.5 font-semibold ${
              isDarkMode ? 'text-indigo-300/80' : 'text-gray-400'
            }`}>
              ID
            </p>
            <p className={`text-[11px] font-mono font-semibold ${
              isDarkMode ? 'text-indigo-200' : 'text-gray-700'
            }`}>
              {customer.id}
            </p>
          </div>
        </div>

        {/* Body: detail rows */}
        <div className={`px-3 py-2 divide-y ${
          isDarkMode ? 'divide-indigo-500/15' : 'divide-gray-100'
        }`}>
          <div className="flex items-center justify-between py-2 gap-3">
            <span className={`text-[10px] font-medium uppercase tracking-wider shrink-0 ${
              isDarkMode ? 'text-indigo-300/70' : 'text-gray-500'
            }`}>
              Email
            </span>
            <span className={`text-[11px] font-medium text-right truncate ${
              isDarkMode ? 'text-slate-300' : 'text-gray-800'
            }`}>
              {customer.email || '—'}
            </span>
          </div>

          <div className="flex items-center justify-between py-2 gap-3">
            <span className={`text-[10px] font-medium uppercase tracking-wider shrink-0 ${
              isDarkMode ? 'text-indigo-300/70' : 'text-gray-500'
            }`}>
              Phone
            </span>
            <span className={`text-[11px] font-mono ${
              isDarkMode ? 'text-slate-300' : 'text-gray-800'
            }`}>
              {customer.phone || '—'}
            </span>
          </div>

          <div className="flex items-center justify-between py-2 gap-3">
            <span className={`text-[10px] font-medium uppercase tracking-wider shrink-0 ${
              isDarkMode ? 'text-indigo-300/70' : 'text-gray-500'
            }`}>
              Status
            </span>
            <div className="flex items-center gap-1.5">
              <button
                onClick={() => handleStatusToggle(customer.id)}
                title={isActive ? "Active (click to deactivate)" : "Inactive (click to activate)"}
                className={`relative inline-flex h-4 w-8 items-center rounded-full transition-all duration-300 ${
                  isActive
                    ? (isDarkMode
                        ? 'bg-gradient-to-r from-emerald-500 to-green-600 shadow-[0_0_10px_rgba(16,185,129,0.5)]'
                        : 'bg-green-500')
                    : (isDarkMode
                        ? 'bg-gray-700'
                        : 'bg-gray-300')
                }`}
              >
                <span
                  className={`inline-block h-3 w-3 transform rounded-full bg-white shadow transition-transform duration-200 ${
                    isActive ? "translate-x-4" : "translate-x-0.5"
                  }`}
                />
              </button>
              <span className={`text-[9px] font-semibold ${
                isActive
                  ? (isDarkMode ? 'text-emerald-400' : 'text-green-600')
                  : (isDarkMode ? 'text-gray-500' : 'text-gray-400')
              }`}>
                {isActive ? "Active" : "Inactive"}
              </span>
            </div>
          </div>
        </div>

        {/* Action buttons */}
        <div className={`flex items-center justify-end gap-2 px-3 py-2 border-t ${
          isDarkMode ? 'border-indigo-500/15 bg-indigo-500/5' : 'border-gray-100 bg-gray-50'
        }`}>
          <button
            onClick={() => handleViewClick(customer)}
            className={`p-1.5 rounded-lg border transition-all duration-200 ${
              isDarkMode
                ? 'border-indigo-500/40 text-indigo-300 hover:bg-indigo-500/10 hover:shadow-[0_0_10px_rgba(99,102,241,0.4)]'
                : 'border-gray-300 text-gray-600 hover:bg-gray-100'
            }`}
            title="View"
          >
            <IoMdEye size={12} />
          </button>
          <button
            onClick={() => handleDelete(customer.id)}
            className={`p-1.5 rounded-lg border transition-all duration-200 ${
              isDarkMode
                ? 'border-rose-500/40 text-rose-400 hover:bg-rose-500/10 hover:shadow-[0_0_10px_rgba(244,63,94,0.4)]'
                : 'border-gray-300 text-gray-600 hover:bg-gray-100'
            }`}
            title="Delete"
          >
            <MdDelete size={12} />
          </button>
          <button
            onClick={() => handleDownloadCSV(customer)}
            className={`p-1.5 rounded-lg border transition-all duration-200 ${
              isDarkMode
                ? 'border-emerald-500/40 text-emerald-400 hover:bg-emerald-500/10 hover:shadow-[0_0_10px_rgba(16,185,129,0.4)]'
                : 'border-gray-300 text-gray-600 hover:bg-gray-100'
            }`}
            title="Download"
          >
            <AiOutlineDownload size={12} />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className={`h-screen flex flex-col overflow-hidden transition-colors duration-300 ${isDarkMode ? 'dark bg-[#0B1120]' : 'bg-gray-50'}`}>
      {/* Premium ambient glows */}
      {isDarkMode ? (
        <>
          <div className="pointer-events-none absolute -top-40 -left-32 h-[500px] w-[500px] rounded-full bg-indigo-600/15 blur-[120px]" />
          <div className="pointer-events-none absolute top-1/2 -right-40 h-[400px] w-[400px] rounded-full bg-emerald-600/10 blur-[100px]" />
        </>
      ) : (
        <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 blur-3xl" />
      )}

      <NavBar />
      <div className="flex flex-1 overflow-hidden relative z-10">
           {isToggleSidebar && (
                        <div
                            className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm md:hidden"
                            onClick={() => setIsToggleSidebar(false)}
                        />
                    )}

                    <div
                        className={`
                     fixed inset-y-0 left-0 z-50 w-64
                     ${isToggleSidebar ? "translate-x-0" : "-translate-x-full"}
                     md:static md:inset-auto md:z-auto md:translate-x-0
                     ${isToggleSidebar ? "md:w-64" : "md:w-[72px]"}
                     m-3
                     rounded-3xl
                 
                     overflow-hidden
                     transition-all
                     duration-300
                     ease-in-out
                   `}
                    >
                        <Sidebar />
                    </div>

        <div className={`flex-1 flex flex-col overflow-hidden p-2.5 sm:p-3 transition-colors duration-300 ${isDarkMode ? 'bg-[#0B1120]' : 'bg-gray-100'}`}>
          <div className={`flex flex-col flex-1 overflow-hidden rounded-2xl border p-2.5 sm:p-3 md:p-4 transition-colors duration-300 ${
            isDarkMode 
              ? 'bg-gradient-to-br from-[#111827] to-[#0F172A] border-gray-800 shadow-[0_0_30px_rgba(0,0,0,0.4)]' 
              : 'bg-white border-gray-200 shadow-sm'
          }`}>

            {/* Premium Header */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 shrink-0">
              <div className="flex items-center gap-2 flex-wrap">
                <div className={`p-2 rounded-lg border transition-all duration-300 flex-shrink-0 ${
                  isDarkMode 
                    ? 'bg-gradient-to-br from-indigo-500/20 to-purple-500/10 border-indigo-500/30 shadow-[0_0_15px_rgba(99,102,241,0.2)]' 
                    : 'border-gray-300'
                }`}>
                  <FaUser size={12} className={isDarkMode ? 'text-indigo-400' : 'text-blue-600'} />
                </div>
                <span className={`text-[11px] font-bold uppercase tracking-[0.15em] ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`}>
                  All Customers
                </span>
                <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full transition-colors duration-300 ${
                  isDarkMode 
                    ? 'bg-indigo-500/15 text-indigo-300 border border-indigo-500/30' 
                    : 'bg-blue-100 text-blue-800'
                }`}>
                  {totalCustomer}
                </span>
              </div>
              {selectAll && (
                <button
                  onClick={handleDownloadAllCustomers}
                  className={`text-[10px] font-semibold px-3 py-1.5 rounded-lg flex items-center gap-1.5 transition-all ${
                    isDarkMode
                      ? 'bg-gradient-to-r from-emerald-600 to-green-600 text-white hover:shadow-[0_0_20px_rgba(16,185,129,0.5)]'
                      : 'bg-blue-800 text-white hover:opacity-80'
                  }`}
                >
                  <AiOutlineDownload size={11} />
                  Download All
                </button>
              )}
            </div>

            {/* Premium Search */}
            <div className="relative w-full mt-3 shrink-0">
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search by Name / ID / Phone..."
                className={`w-full pl-8 pr-3 py-2 text-[10px] rounded-xl border focus:outline-none transition-all duration-300 ${
                  isDarkMode
                    ? 'border-white/10 bg-white/[0.03] text-white placeholder-gray-500 focus:border-indigo-500/60 focus:bg-white/[0.06] focus:ring-2 focus:ring-indigo-500/20'
                    : 'border-gray-300 bg-white text-gray-800 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500'
                }`}
              />
              <Search className={`absolute left-2.5 top-1/2 transform -translate-y-1/2 w-3.5 h-3.5 ${
                isDarkMode ? 'text-indigo-400' : 'text-gray-400'
              }`} />
            </div>

            {/* Premium Table */}
            <div className={`flex-1 overflow-y-auto overflow-x-auto mt-3 rounded-xl border custom-scrollbar transition-colors duration-300 ${
              isDarkMode 
                ? 'border-gray-800 shadow-[0_0_20px_rgba(0,0,0,0.3)]' 
                : 'border-gray-200'
            }`}>
              {/* Mobile/Tablet Card View (hidden on lg+) */}
              <div className="lg:hidden p-2 space-y-3">
                {displayCustomers.length === 0 ? (
                  <div className={`text-center py-6 text-[10px] ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                    No customers found
                  </div>
                ) : (
                  displayCustomers.map((customer, index) => renderMobileCard(customer, index))
                )}
              </div>

              {/* Desktop Table View (hidden below lg) */}
              <table className="hidden lg:table min-w-full w-full table-fixed">
                <thead className={`text-[9px] uppercase tracking-wider sticky top-0 z-10 transition-colors duration-300 ${
                  isDarkMode
                    ? 'bg-gradient-to-r from-[#1F2937] via-[#1a2332] to-[#1F2937] text-gray-300 border-b border-gray-700'
                    : 'bg-emerald-600 text-white'
                }`}>
                  <tr>
                    <th className='p-2 text-center' style={{ width: '14.28%' }}>
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                        className={`cursor-pointer ${isDarkMode ? 'accent-indigo-500' : 'accent-blue-800'}`}
                      />
                    </th>
                    <th className="p-2 text-left font-semibold" style={{ width: '14.28%' }}>ID</th>
                    <th className="p-2 text-left font-semibold" style={{ width: '14.28%' }}>Name</th>
                    <th className="p-2 text-left font-semibold" style={{ width: '14.28%' }}>Email</th>
                    <th className="p-2 text-left font-semibold" style={{ width: '14.28%' }}>Phone</th>
                    <th className="p-2 text-center font-semibold" style={{ width: '14.28%' }}>Status</th>
                    <th className="p-2 text-center font-semibold" style={{ width: '14.28%' }}>Actions</th>
                  </tr>
                </thead>
                <tbody className={`divide-y transition-colors duration-300 ${
                  isDarkMode ? 'divide-gray-800' : 'divide-gray-100'
                }`}>
                  {displayCustomers.length === 0 ? (
                    <tr>
                      <td colSpan="7" className={`p-6 text-center text-[10px] ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                        No customers found
                      </td>
                    </tr>
                  ) : (
                    displayCustomers.map((customer, index) => {
                      const isActive = customer.status === 1 || customer.status === "active";
                      return (
                        <tr 
                          key={customer.id} 
                          className={`transition-colors duration-150 ${
                            isDarkMode 
                              ? index % 2 === 0 ? 'bg-[#111827] hover:bg-[#1F2937]' : 'bg-[#0F172A] hover:bg-[#1F2937]' 
                              : 'hover:bg-gray-50'
                          }`}
                        >
                          <td className='p-2 text-center' style={{ width: '14.28%' }}>
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(index)}
                              onChange={() => handleRowSelect(index)}
                              className={`cursor-pointer ${isDarkMode ? 'accent-indigo-500' : 'accent-gray-800'}`}
                            />
                          </td>
                          <td className={`p-2 text-[10px] font-mono truncate ${isDarkMode ? 'text-indigo-300' : 'text-gray-500'}`} style={{ width: '14.28%' }}>{customer.id}</td>
                          <td className={`p-2 text-[10px] font-semibold truncate ${isDarkMode ? 'text-gray-200' : 'text-gray-800'}`} style={{ width: '14.28%' }}>{customer.name}</td>
                          <td className={`p-2 text-[10px] truncate ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`} style={{ width: '14.28%' }}>{customer.email}</td>
                          <td className={`p-2 text-[10px] font-mono truncate ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`} style={{ width: '14.28%' }}>{customer.phone}</td>
                          {/* Premium Status Toggle */}
                          <td className="p-2 text-center" style={{ width: '14.28%' }}>
                            <div className="flex items-center justify-center gap-1.5">
                              <button
                                onClick={() => handleStatusToggle(customer.id)}
                                title={isActive ? "Active (click to deactivate)" : "Inactive (click to activate)"}
                                className={`relative inline-flex h-4 w-8 items-center rounded-full transition-all duration-300 ${
                                  isActive 
                                    ? (isDarkMode 
                                        ? 'bg-gradient-to-r from-emerald-500 to-green-600 shadow-[0_0_10px_rgba(16,185,129,0.5)]' 
                                        : 'bg-green-500') 
                                    : (isDarkMode 
                                        ? 'bg-gray-700' 
                                        : 'bg-gray-300')
                                }`}
                              >
                                <span
                                  className={`inline-block h-3 w-3 transform rounded-full bg-white shadow transition-transform duration-200 ${
                                    isActive ? "translate-x-4" : "translate-x-0.5"
                                  }`}
                                />
                              </button>
                              <span className={`text-[9px] font-semibold ${
                                isActive 
                                  ? (isDarkMode ? 'text-emerald-400' : 'text-green-600') 
                                  : (isDarkMode ? 'text-gray-500' : 'text-gray-400')
                              }`}>
                                {isActive ? "Active" : "Inactive"}
                              </span>
                            </div>
                          </td>
                          <td className="p-2" style={{ width: '14.28%' }}>
                            <div className="flex items-center justify-center gap-1">
                              {/* View Button */}
                              <button
                                onClick={() => handleViewClick(customer)}
                                className={`p-1.5 rounded-lg border transition-all duration-200 ${
                                  isDarkMode
                                    ? 'border-indigo-500/40 text-indigo-300 hover:bg-indigo-500/10 hover:shadow-[0_0_10px_rgba(99,102,241,0.4)]'
                                    : 'border-gray-300 text-gray-600 hover:bg-gray-100'
                                }`}
                                title="View"
                              >
                                <IoMdEye size={12} />
                              </button>
                              {/* Delete Button */}
                              <button
                                onClick={() => handleDelete(customer.id)}
                                className={`p-1.5 rounded-lg border transition-all duration-200 ${
                                  isDarkMode
                                    ? 'border-rose-500/40 text-rose-400 hover:bg-rose-500/10 hover:shadow-[0_0_10px_rgba(244,63,94,0.4)]'
                                    : 'border-gray-300 text-gray-600 hover:bg-gray-100'
                                }`}
                                title="Delete"
                              >
                                <MdDelete size={12} />
                              </button>
                              {/* Download Button */}
                              <button
                                onClick={() => handleDownloadCSV(customer)}
                                className={`p-1.5 rounded-lg border transition-all duration-200 ${
                                  isDarkMode
                                    ? 'border-emerald-500/40 text-emerald-400 hover:bg-emerald-500/10 hover:shadow-[0_0_10px_rgba(16,185,129,0.4)]'
                                    : 'border-gray-300 text-gray-600 hover:bg-gray-100'
                                }`}
                                title="Download"
                              >
                                <AiOutlineDownload size={12} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Premium Footer */}
            <div className={`mt-3 flex flex-col sm:flex-row justify-between items-center gap-2 shrink-0 pt-3 border-t transition-colors duration-300 ${
              isDarkMode ? 'border-gray-800' : 'border-gray-100'
            }`}>
              <span className={`text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                Total: <span className={`font-bold ${isDarkMode ? 'text-indigo-300' : 'text-gray-800'}`}>{totalCustomer}</span> customers
              </span>
              <div className="flex items-center gap-2">
                <select
                  id="limit"
                  value={limit}
                  onChange={handleLimitChange}
                  className={`border rounded-lg p-1 text-[9px] focus:outline-none transition-colors duration-300 ${
                    isDarkMode
                      ? 'border-gray-700 bg-[#1F2937] text-gray-200 focus:ring-1 focus:ring-indigo-500'
                      : 'border-gray-300 bg-white text-gray-800 focus:ring-1 focus:ring-gray-500'
                  }`}
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={25}>25</option>
                  <option value={30}>30</option>
                  <option value={totalCustomer}>All</option>
                </select>
                <Pagination
                  count={Math.ceil(totalCustomer / limit)}
                  page={currentPage}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  size="small"
                  sx={{
                    '& .MuiPaginationItem-root': {
                      fontSize: '10px',
                      borderColor: isDarkMode ? '#374151' : '#d1d5db',
                      color: isDarkMode ? '#E5E7EB' : '#374151',
                      '&.Mui-selected': {
                        backgroundColor: isDarkMode ? 'rgba(99,102,241,0.2)' : '#000',
                        color: isDarkMode ? '#a5b4fc' : '#fff',
                        borderColor: isDarkMode ? '#6366f1' : '#000',
                        boxShadow: isDarkMode ? '0 0 10px rgba(99,102,241,0.4)' : 'none',
                      },
                      '&:hover': {
                        backgroundColor: isDarkMode ? 'rgba(99,102,241,0.1)' : '#F3F4F6',
                      }
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <ViewAllCustomerModel isopen={isPopupOpen} onClose={handleClose} customer={selectedCustomer} />
      </div>
    </div>
  );
};

export default ViewAllCustomer;